export default "__VITE_ASSET__d5fbc5cc__"